import { firebaseDb, uid } from './index'

export const saveSettings = settings => {
  firebaseDb().ref(`users/${uid()}/settings`).set(settings)
    .catch((error) => {
      console.log(error)
    })
}



// WEBPACK FOOTER //
// ./src/Firebase/apiSetting.js